import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { Modal, Button } from 'react-bootstrap';
import ZoomIcon from '../assets/images/zoom-out-2.svg';

const Zoom = ({ chartData, chartLayout, chartTitle }) => {
  const [showModal, setShowModal] = useState(false);

  // Toggle modal visibility
  const handleToggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      {/* Magnifier Button */}
      <Button
        variant="link"
        onClick={handleToggleModal}
        style={{ paddingLeft: 0, lineHeight: 0,marginLeft: 5}}
        title="Enlarge Chart"
      >
        <img src={ZoomIcon} alt="Zoom Icon" width="24" height="20" />
      </Button>

      {/* Modal for Enlarged Chart */}
      <Modal
        show={showModal}
        onHide={handleToggleModal}
        size="xl"
        centered
        dialogStyle={{ maxWidth: '90%' }}
        style={{ borderRadius: '8px' }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{chartTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px', overflowX: 'auto' }}>
          {chartData && chartLayout && (
            <Plot
              data={chartData}
              layout={{
                ...chartLayout,
                margin: { t: 10, r: 10, l: 10, b: 200 },

              }}
              useResizeHandler={true}
              style={{ width: '100%', height: '100%' }}
              config={{
                responsive: true,
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleToggleModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

Zoom.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.object),
  chartLayout: PropTypes.object,
  chartTitle: PropTypes.string.isRequired,
};

export default Zoom;